import { combineReducers } from 'redux';
import {
  FETCH_ZONES,
  FETCH_ZONES_SUCCESS,
  CREATE_ZONE,
  CREATE_ZONE_SUCCESS,
  CREATE_ZONE_ERROR,
  COPY_ZONE,
  COPY_ZONE_SUCCESS,
} from '../actions/zones';
import { Set } from 'immutable';

const byId = (state = {}, action) => {
  if (action.response) {
    return {
      ...state,
      ...action.response.entities.zones,
    };
  }

  return state;
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case FETCH_ZONES_SUCCESS:
      return action.response.result;
    case CREATE_ZONE_SUCCESS:
    case COPY_ZONE_SUCCESS:
      return [...state, action.response.result];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_ZONES:
      return true;
    case FETCH_ZONES_SUCCESS:
      return false;
    default:
      return state;
  }
};

const hasCreateError = (state = false, action) => {
  switch (action.type) {
    case CREATE_ZONE:
    case CREATE_ZONE_SUCCESS:
      return false;
    case CREATE_ZONE_ERROR:
      return true;
    default:
      return state;
  }
};

const isCreating = (state = false, action) => {
  switch (action.type) {
    case CREATE_ZONE:
      return true;
    case CREATE_ZONE_SUCCESS:
      return false;
    default:
      return state;
  }
};

const isCopying = (state = false, action) => {
  switch (action.type) {
    case COPY_ZONE:
      return true;
    case COPY_ZONE_SUCCESS:
      return false;
    default:
      return state;
  }
};

const zones = combineReducers({
  byId,
  allIds,
  isFetching,
  isCreating,
  isCopying,
  hasCreateError,
});

export default zones;

export const getIsFetching = state => state.manips.zones.isFetching;

export const getIsCreating = state => state.manips.zones.isCreating;

export const getIsCopying = state => state.manips.zones.isCopying;

export const getHasCreateError = state => state.manips.zones.hasCreateError;

const getAllZones = state =>
  state.manips.zones.allIds.map(id => state.manips.zones.byId[id]);

export const getSortedZones = state => {
  const allZones = getAllZones(state);
  return Set(allZones)
    .sortBy(z => z.order)
    .toArray();
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/zones.js